module.exports = __webpack_public_path__ + "static/media/fly0096.dce5906b.webp";